import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = ({ fill, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={fill || "currentColor"}
      fillRule="evenodd"
      d="M12 5a2 2 0 1 0 0 4 2 2 0 0 0 0-4ZM8 7a4 4 0 1 1 8 0 4 4 0 0 1-8 0ZM4 9a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-3 1a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm19-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-3 1a3 3 0 1 1 6 0 3 3 0 0 1-6 0ZM6.965 14.735A5.995 5.995 0 0 1 12 12a5.995 5.995 0 0 1 5.035 2.735A4.5 4.5 0 0 1 24 18.5V21H0v-2.5a4.5 4.5 0 0 1 6.965-3.765Zm1.036 3.162L8 18v1h8v-1a4.002 4.002 0 0 0-4-4 4 4 0 0 0-3.999 3.897ZM18 18v1h4v-.5a2.5 2.5 0 0 0-4.157-1.872A6.003 6.003 0 0 1 18 18ZM6 19v-1a6.102 6.102 0 0 1 .158-1.372A2.5 2.5 0 0 0 2 18.5v.5h4Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgComponent;
